'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _unsubscribe = require('../../helpers/unsubscribe');

var _FormInput = require('../FormInput');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeComp = function UnsubscribeComp(_ref) {
  var unsubscribe = _ref.unsubscribe;

  var _ref2 = unsubscribe || {},
      loading = _ref2.loading,
      scope = _ref2.scope,
      token = _ref2.token,
      success = _ref2.success,
      error = _ref2.error;

  if (loading) {
    return _react2.default.createElement(
      'div',
      { className: 'container text-center' },
      _react2.default.createElement(
        'h1',
        null,
        'Redirecting...'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Please wait while we process your unsubscribe request.'
      )
    );
  }

  if (error) {
    return _react2.default.createElement(
      'div',
      { className: 'container text-center' },
      _react2.default.createElement(
        'h1',
        null,
        'Something went wrong'
      ),
      _react2.default.createElement(
        'p',
        null,
        'We were unable to process your unsubscribe request. Please try again later or contact support.'
      )
    );
  }

  if (success) {
    if (scope === _unsubscribe.Scope.full) {
      return _react2.default.createElement(
        'div',
        { className: 'container text-center' },
        _react2.default.createElement(
          'h1',
          null,
          'Unsubscribe Successful'
        ),
        _react2.default.createElement(
          'p',
          null,
          'You have been successfully unsubscribed from all future marketing email.',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }

    var href = '/en/store/unsubscribe?scope=' + _unsubscribe.Scope.full + '&token=' + token;

    return _react2.default.createElement(
      'div',
      { className: 'container text-center' },
      _react2.default.createElement(
        'h1',
        null,
        'Unsubscribe Successful'
      ),
      _react2.default.createElement(
        'p',
        null,
        'You have been successfully unsubscribed from all future abandoned cart reminders.'
      ),
      _react2.default.createElement(
        'div',
        { styleName: 'unsubscribeBtn' },
        _react2.default.createElement(
          _FormInput.ButtonLink,
          { url: href, weight: 'secondary' },
          'Unsubscribe from all marketing emails'
        )
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'container text-center' },
    _react2.default.createElement(
      'h1',
      null,
      'Processing Unsubscribe Request'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Please wait while we process your request...'
    )
  );
};

UnsubscribeComp.displayName = 'UnsubscribeComp';
UnsubscribeComp.propTypes = {
  unsubscribe: _propTypes2.default.object
};

exports.default = (0, _reactCssModules2.default)(UnsubscribeComp, _style2.default, { allowMultiple: true });
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Unsubscribe/index.js
// module id = 2505
// module chunks = 0